// src/components/layout/Layout.tsx
import React, { useState, useEffect } from 'react';
import { Box, CssBaseline, Toolbar, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  // Ha nem admin, átirányítás a default_app-ra
  useEffect(() => {
    if (user && user.role !== 'admin' && user.default_app) {
      let redirectUrl = user.default_app;
      if (!redirectUrl.endsWith('/')) {
        redirectUrl += '/';
      }
      window.location.href = redirectUrl;
    }
  }, [user]);

  // Csak admin felhasználók esetén jelenítjük meg a layout-ot
  if (user?.role !== 'admin') {
    return null; // Nem jelenítünk meg semmit az átirányítás alatt
  }

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      <Header onMenuToggle={toggleDrawer} isSidebarOpen={open} />
      <Sidebar open={open} handleDrawerClose={toggleDrawer} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${open ? 240 : theme.spacing(7)})` },
          bgcolor: theme.palette.background.default,
          mt: 0,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Layout;